module.exports = __webpack_public_path__ + "images/sns_campaign_lp/mainvisual-title-pc_0642fc440c60688cfda9e56661e69c96.png";